import { useEffect, useState } from 'react';
/**
 * Delays a rapidly-changing value until it settles.
 *
 * Every search box in both apps put its raw `onChange` state straight into a
 * react-query key, which is one HTTP request per keystroke — "Indomaret" was
 * nine round trips, eight of them already stale on arrival. That was survivable
 * while the endpoints returned a capped array from a three-row seed; against a
 * paginated `ILIKE '%…%'` over a real outlet table it is eight full scans.
 *
 * The delay belongs here rather than in the query layer: react-query cannot know
 * whether a changing key means "the user typed another letter" or "the user
 * picked a different region", and only the first should wait.
 *
 * Returns the previous value until `delay` has passed with no further change, so
 * the first render is never empty.
 */
export function useDebouncedValue(value, delay = 300) {
    const [settled, setSettled] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setSettled(value), delay);
        // Clearing on every change is what makes this a debounce rather than a
        // throttle: continuous typing pushes the deadline out instead of firing at
        // a fixed cadence.
        return () => clearTimeout(timer);
    }, [value, delay]);
    return settled;
}
//# sourceMappingURL=use-debounced-value.js.map